export const Env = {
    REACT_APP_API_URL: window.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
    REACT_APP_SOCKET_URL: window.REACT_APP_SOCKET_URL || process.env.REACT_APP_SOCKET_URL,
    REACT_APP_VERSION: window.REACT_APP_VERSION || process.env.REACT_APP_VERSION,
    REACT_APP_IFRAME: window.REACT_APP_IFRAME || process.env.REACT_APP_IFRAME,
    REACT_APP_BASIC_TOKEN: window.REACT_APP_BASIC_TOKEN || process.env.REACT_APP_BASIC_TOKEN,
    REACT_APP_X_MERCHANT_ID: window.REACT_APP_X_MERCHANT_ID || process.env.REACT_APP_X_MERCHANT_ID
};

